<template>
  <b-modal title="Relatório de Faturamento" v-model="show" size="xl">
    <div id="relatorioDeFaturamento">
      <b-container fluid>
        <!-- :::::::::::::::::::::::::::: HEADER DA RELATORIO DE SERVIÇO :::::::::::::::::::::::::::: -->
        <b-row class="mt-2">
          <b-col cols="2">
            <img class="m-2" :src="require('/static/images/logo_sgcq.png')" aria-label="Logomarca do SGCQ" width="160" />
          </b-col>
          <b-col cols="7">
            <h3>NEW ENERGY TECH EIRELI</h3>
            <h6>Serviços Técnicos de Consultória, Projeto, Fabricação, Inspeção de Equipamentos.</h6>
            <h6>BR 304 - Km 50,5 - Zona Rural</h6>
            <h6>Fone: (84) 9 9604-4935 / (84) 9 8740-0525</h6>
          </b-col>
          <b-col cols="3" class="text-right">
            <b-form-group label-cols-sm="3" label="Data:" label-align-sm="right" label-for="data">
              <b-form-datepicker
                id="data"
                v-model="data"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col cols="6">
            <b-form-group label="Cliente:" label-for="cliente" label-cols-sm="3" label-align-sm="right">
              <b-form-input id="cliente" type="search" size="sm" class="m-1 p-1" placeholder="Cliente" v-model="filtro.cliente" />
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="Mostrar pelo status:" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                v-model="filtro.pago"
                :options="options"
                :aria-describedby="ariaDescribedby"
                name="radio-options"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <hr />
        <b-row class="mt-2">
          <b-col cols="12" class="text-center">
            <h4><strong>RELATÓRIO DE FATURAMENTO</strong></h4>
          </b-col>
        </b-row>

        <!-- :::::::::::::::::::::::::::: TABELA DE ITENS :::::::::::::::::::::::::::: -->
        <b-table
          bordered
          hover
          small
          head-variant="light"
          :items="getFilterFaturamentos(filtro)"
          :fields="fields.faturamentoRelatorio"
        >
          <template #cell(data)="data">
            <div>
              <p class="pt-0 pb-0">
                {{ moment(data.item.data).format("DD/MM/YYYY") }}
              </p>
            </div>
          </template>

          <template #cell(total)="data">
            <div>
              <p>{{ formatter.format(data.item.total) }}</p>
            </div>
          </template>
        </b-table>
        <!-- :::::::::::::::::::::::::::: TOTAL :::::::::::::::::::::::::::: -->
        <b-row>
          <b-col offset="7" cols="5">
            <h5 class="text-right">
              <strong>Total: {{ formatter.format(getTotal) }}</strong>
            </h5>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <template #modal-footer>
      <b-form inline>
        <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
        <b-form-input
          id="fat-filter-id"
          type="number"
          size="sm"
          variant="warning"
          class="m-1 p-1"
          placeholder="Id"
          v-model="filtro.id"
        />
        <b-form-input
          id="fat-filter-desc"
          type="search"
          size="sm"
          variant="warning"
          class="m-1 p-1"
          placeholder="Descrição"
          v-model="filtro.descricao"
        />
        <b-form-input
          id="fat-filter-orc"
          type="search"
          size="sm"
          class="m-1 p-1"
          placeholder="Orçamento"
          v-model="filtro.orcamento"
        />
        <b-form-input id="fat-filter-nota" type="search" size="sm" class="m-1 p-1" placeholder="Nota" v-model="filtro.nota" />
      </b-form>
      <b-button variant="primary" v-print="impressao">Imprimir</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useClienteStore } from "@/stores/ClienteStore";
import { useFaturamentoStore } from "@/stores/FaturamentoStore";
import TableFields from "@/tools/TableFields";

export default {
  name: "ModalDeRelatorioDeFaturamento",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      data: new Date(),
      cliente: null,
      filtro: {
        id: "",
        descricao: "",
        cliente: "",
        orcamento: "",
        nota: "",
        pago: false,
      },
      formatter: new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }),
      options: [
        { text: "Todos", value: null },
        { text: "Pagos", value: true },
        { text: "Não Pagos", value: false },
      ],
      impressao: {
        id: "relatorioDeFaturamento",
        popTitle: "SGCQ - Sistema de Gestão e Controle da Qualidade",
      },
    };
  },

  methods: {
    call() {
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const clienteStore = useClienteStore();
    const faturamentoStore = useFaturamentoStore();
    const { getFilterFaturamentos } = storeToRefs(faturamentoStore);
    const { getTotal } = storeToRefs(faturamentoStore);

    return {
      store,
      clienteStore,
      faturamentoStore,
      getFilterFaturamentos,
      getTotal,
    };
  },
};
</script>

<style lang="scss" scoped></style>
